var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareOptionBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share-option",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.485,
    height: 15.612,
    viewBox: "0 0 17.485 15.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11300",
    "data-name": "Path 11300",
    d: "M17.3,32.589l-5-5a.625.625,0,0,0-1.064.439v2.5H9.055Q2.1,30.53.517,34.463A8.886,8.886,0,0,0,0,37.712a11.717,11.717,0,0,0,1.239,4.4q.029.068.1.234t.132.293a1.109,1.109,0,0,0,.127.214.334.334,0,0,0,.273.166.285.285,0,0,0,.229-.1.364.364,0,0,0,.083-.244,1.987,1.987,0,0,0-.024-.259,2.018,2.018,0,0,1-.024-.229q-.049-.663-.049-1.2a8.305,8.305,0,0,1,.171-1.766,5.3,5.3,0,0,1,.473-1.351,3.394,3.394,0,0,1,.781-.985,4.581,4.581,0,0,1,1.029-.678,5.581,5.581,0,0,1,1.3-.415,12.374,12.374,0,0,1,1.5-.21q.756-.059,1.713-.058h2.186v2.5a.621.621,0,0,0,1.064.439l5-5a.613.613,0,0,0,0-.878Z",
    transform: "translate(0 -27.408)",
    fill: "#0074b0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOptionBlue);
export default __webpack_public_path__ + "static/media/share-option-blue.45aede9841b29e4cf22700126232d82c.svg";
export { ForwardRef as ReactComponent };